export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/az.a387da6a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};